/* BMM Autosports fitment and filter helpers */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function initVehicleFinder() {
    var form = document.querySelector('[data-bmm-vehicle-finder]');
    if (!form) return;

    var year = form.querySelector('[name="vehicle_year"]');
    var make = form.querySelector('[name="vehicle_make"]');
    var model = form.querySelector('[name="vehicle_model"]');
    var clear = form.querySelector('[data-bmm-clear-vehicle]');

    var saved = {};
    try { saved = JSON.parse(localStorage.getItem('bmmVehicle') || '{}'); } catch (e) {}

    if (year && saved.year) year.value = saved.year;
    if (make && saved.make) make.value = saved.make;
    if (model && saved.model) model.value = saved.model;

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var payload = {
        year: year ? year.value.trim() : '',
        make: make ? make.value.trim() : '',
        model: model ? model.value.trim() : ''
      };
      localStorage.setItem('bmmVehicle', JSON.stringify(payload));

      var terms = [payload.year, payload.make, payload.model, 'wiper blades'].filter(Boolean).join(' ');
      var url = new URL('/search', window.location.origin);
      url.searchParams.set('type', 'product');
      url.searchParams.set('q', terms);
      window.location.href = url.toString();
    });

    if (clear) {
      clear.addEventListener('click', function () {
        localStorage.removeItem('bmmVehicle');
        if (year) year.value = '';
        if (make) make.value = '';
        if (model) model.value = '';
      });
    }
  }

  function initVariantSync() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      var idInput = form.querySelector('input[name="id"]');
      var data = form.querySelector('[data-bmm-variant-json]');
      if (!idInput || !data) return;

      var variants;
      try { variants = JSON.parse(data.textContent); } catch (e) { return; }

      var selects = form.querySelectorAll('select[name^="options["]');

      function sync() {
        var selected = Array.prototype.map.call(selects, function (select) { return select.value; });
        var match = variants.find(function (variant) {
          return variant.options.every(function (option, index) { return option === selected[index]; });
        });

        if (!match) return;
        idInput.value = match.id;

        var button = form.querySelector('button[name="add"]');
        if (button) {
          button.disabled = !match.available;
          button.textContent = match.available ? 'Add to cart' : 'Sold out';
        }
      }

      selects.forEach(function (select) { select.addEventListener('change', sync); });
      sync();
    });
  }

  ready(function () {
    initVehicleFinder();
    initVariantSync();
  });
})();
